/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

export const PER_MONTH = 'month'
export const PER_QUARTER = 'quarter'
export const PER_SEMESTER = 'semester'
export const PER_YEAR = 'year'

export function isInPeriod (frequency, dateTime, future = false) {
  const { month } = dateTime

  if (future) {
    if (frequency === PER_MONTH) {
      return true
    }
    if (frequency === PER_QUARTER) {
      return [1, 4, 7, 10].includes(month)
    }
    if (frequency === PER_SEMESTER) {
      return [1, 7].includes(month)
    }
    if (frequency === PER_YEAR) {
      return month === 1
    }
  } else {
    if (frequency === PER_MONTH) {
      return true
    }
    if (frequency === PER_QUARTER) {
      return [3, 6, 9, 12].includes(month)
    }
    if (frequency === PER_SEMESTER) {
      return [6, 12].includes(month)
    }
    if (frequency === PER_YEAR) {
      return month === 12
    }
  }
  return false
}
